import { render, staticRenderFns } from "./VesselSpecs.vue?vue&type=template&id=42d43ddc&scoped=true"
import script from "./VesselSpecs.vue?vue&type=script&lang=js"
export * from "./VesselSpecs.vue?vue&type=script&lang=js"
import style0 from "./VesselSpecs.vue?vue&type=style&index=0&id=42d43ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d43ddc",
  null
  
)

export default component.exports